import { useState, useCallback } from 'react';

const KEY = 'zakat_portfolio';
const MAX = 20;

function load() {
  try { return JSON.parse(sessionStorage.getItem(KEY)) || []; }
  catch { return []; }
}

function persist(items) {
  try { sessionStorage.setItem(KEY, JSON.stringify(items)); } catch {}
}

function genId() {
  return Math.random().toString(36).slice(2, 10);
}

export function usePortfolio() {
  const [holdings, setHoldings] = useState(load);

  const addHolding = useCallback((ticker, shares) => {
    const t = ticker.toUpperCase().trim();
    setHoldings(prev => {
      if (prev.find(h => h.ticker === t)) return prev; // no dupes
      const next = [...prev, { id: genId(), ticker: t, shares: Number(shares) || 0 }].slice(0, MAX);
      persist(next);
      return next;
    });
  }, []);

  const updateHolding = useCallback((id, shares) => {
    setHoldings(prev => {
      const next = prev.map(h => h.id === id ? { ...h, shares: Number(shares) || 0 } : h);
      persist(next);
      return next;
    });
  }, []);

  const removeHolding = useCallback((id) => {
    setHoldings(prev => {
      const next = prev.filter(h => h.id !== id);
      persist(next);
      return next;
    });
  }, []);

  const clearHoldings = useCallback(() => {
    setHoldings([]);
    persist([]);
  }, []);

  return { holdings, addHolding, updateHolding, removeHolding, clearHoldings };
}
